import { connect } from 'react-redux';

import add from '../../../REST/add';
import { updateBookingEntry } from '../../actions/booking-entry-actions';
import BookingEntryForm from '../BookingEntryForm';
import { transformForPatch } from '../transform-booking-entry-helpers';

const mapStateToProps = ({ balance }, { id, invoiceId }) => {
  const bookingEntries = invoiceId
    ? balance.invoices.find(invoice => invoice.id === invoiceId).bookingEntries
    : balance.bookingEntries;
  return {
    default: bookingEntries.find(entry => entry.id === id),
  };
};

const mapDispatchToProps = { onUpdate: updateBookingEntry };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  add({
    update: ({ id, onUpdate, onSuccess }, changedModel) =>
      onUpdate(id, transformForPatch(changedModel)).then(onSuccess),
    form: BookingEntryForm,
  }),
);
